import { ButtonLink } from '@/components/ui/button';
import { Page, PageHeader } from '@/components/layout/page';
import { NewsletterForm } from '@/components/newsletter/newsletter-form';
import { DevNote } from '@/components/ui/dev-note';
import { Card, CardBody, Container, Section } from '@/components/ui/primitives';
import { paths } from '@/lib/paths';

/**
 * Page d'inscription à la newsletter — `POST /newsletter/subscribe`.
 *
 * Le formulaire lui-même vit dans `components/newsletter/newsletter-form.tsx`,
 * puisqu'il est également utilisé dans le pied de page.
 */
export default function NewsletterPage() {
    return (
        <Page title="Newsletter">
            <PageHeader
                eyebrow="Restons en contact"
                title="La newsletter Helvedoc"
                description="Les évolutions du service et nos repères pour lire une fiche d'entreprise. Quelques envois par an, pas davantage."
            />

            <Section>
                <Container className="grid items-start gap-10 lg:grid-cols-[1.1fr_1fr]">
                    <Card>
                        <CardBody className="space-y-6">
                            <NewsletterForm variant="full" />

                            <p className="text-ink-muted border-line border-t pt-4 text-xs leading-relaxed">
                                Vous pouvez vous désinscrire à tout moment, en un clic depuis n'importe lequel de nos
                                messages, ou depuis{' '}
                                <a href={paths.unsubscribe} className="text-brand-700 underline">
                                    la page de désinscription
                                </a>
                                .
                            </p>
                        </CardBody>
                    </Card>

                    <div className="space-y-6">
                        <div className="prose-doc">
                            <h2>Ce que vous recevrez</h2>
                            <ul>
                                <li>Les nouveautés du service et les champs nouvellement couverts</li>
                                <li>Des repères pour interpréter une fiche d'entreprise</li>
                                <li>Rien d'autre : ni publicité tierce, ni revente d'adresse</li>
                            </ul>
                        </div>

                        <DevNote
                            title="Ce que fait cet écran"
                            endpoints={['POST /newsletter/subscribe', 'POST /newsletter/unsubscribe']}
                        >
                            <p>
                                La réponse est <strong>identique</strong> que l'adresse soit déjà inscrite ou non : un
                                formulaire public n'a pas à révéler qui figure dans la liste. Affichez donc toujours la
                                même confirmation.
                            </p>
                            <p>
                                Un désabonnement antérieur est respecté : une adresse désinscrite n'est jamais
                                réabonnée en silence — pas même par l'inscription automatique qui suit un achat.
                            </p>
                            <p>
                                L'inscription peut déclencher une séquence de messages, si le site en a configuré une.
                            </p>
                        </DevNote>

                        <ButtonLink to={paths.unsubscribe} variant="secondary" size="sm">
                            Se désinscrire
                        </ButtonLink>
                    </div>
                </Container>
            </Section>
        </Page>
    );
}
